module.exports = {
	"name": "react-step",
	"mainModule": "dist/src/index.js",
	"outDir": "dist",
	"typeDeclaration": {
		"54": "1",
		"55": "4",
		"63": "2",
		"68": "3",
		"94": "6",
		"234": "8",
		"247": "13",
		"394": "20",
		"396": "21",
		"397": "22",
		"421": "23",
		"459": "27",
		"539": "32",
		"591": "34"
	},
	"declarationModule": {
		"0": "dist/src/entities.js",
		"1": "dist/src/entities.js",
		"2": "dist/src/entities.js",
		"3": "dist/src/entities.js",
		"4": "dist/src/entities.js",
		"5": "dist/src/with-stepper.js",
		"6": "dist/src/buttons.js",
		"7": "dist/src/buttons.js",
		"8": "dist/src/buttons.js",
		"9": "dist/src/buttons.js",
		"10": "dist/src/utils.js",
		"11": "dist/src/utils.js",
		"12": "dist/src/utils.js",
		"13": "dist/src/utils.js",
		"14": "dist/src/utils.js",
		"15": "dist/src/utils.js",
		"16": "dist/src/utils.js",
		"17": "dist/src/utils.js",
		"18": "dist/src/dot-tracker.js",
		"19": "dist/src/step-title.js",
		"20": "dist/src/stepper.js",
		"21": "dist/src/stepper.js",
		"22": "dist/src/stepper.js",
		"23": "dist/src/stepper-view.js",
		"24": "dist/src/text-tracker.js",
		"25": "dist/src/react-toolbox/buttons.js",
		"26": "dist/src/react-toolbox/buttons.js",
		"27": "dist/src/react-toolbox/step-circle.js",
		"28": "dist/src/react-toolbox/step-circle.js",
		"29": "dist/src/react-toolbox/step-circle.js",
		"30": "dist/src/react-toolbox/step-circle.js",
		"31": "dist/src/react-toolbox/step-circle.js",
		"32": "dist/src/react-toolbox/step-header.js",
		"33": "dist/src/react-toolbox/step-header.js",
		"34": "dist/src/react-toolbox/vertical-stepper.js",
		"35": "dist/src/react-toolbox/vertical-stepper.js",
		"36": "dist/src/react-toolbox/vertical-stepper.js"
	},
	"modules": {
		"dist/src/entities.js": {
			"name": "entities",
			"srcPath": "src/entities.tsx",
			"outPath": "dist/src/entities.js",
			"declarations": {
				"0": {
					"id": "0",
					"kind": "Variable",
					"exportedIn": [],
					"name": "stepperContext",
					"documentation": "The stepper context as PropTypes to be consumed by React",
					"type": {
						"kind": "Object",
						"properties": [
							{
								"name": "pages",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "Requireable",
									"parameters": [
										{
											"kind": "Named",
											"name": "any",
											"id": 1
										}
									],
									"id": 51,
									"importedFrom": "react"
								},
								"optional": false
							},
							{
								"name": "currentPage",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "Requireable",
									"parameters": [
										{
											"kind": "Named",
											"name": "any",
											"id": 1
										}
									],
									"id": 51,
									"importedFrom": "react"
								},
								"optional": false
							},
							{
								"name": "canAdvance",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "Requireable",
									"parameters": [
										{
											"kind": "Named",
											"name": "any",
											"id": 1
										}
									],
									"id": 51,
									"importedFrom": "react"
								},
								"optional": false
							},
							{
								"name": "canFinish",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "Requireable",
									"parameters": [
										{
											"kind": "Named",
											"name": "any",
											"id": 1
										}
									],
									"id": 51,
									"importedFrom": "react"
								},
								"optional": false
							},
							{
								"name": "canReverse",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "Requireable",
									"parameters": [
										{
											"kind": "Named",
											"name": "any",
											"id": 1
										}
									],
									"id": 51,
									"importedFrom": "react"
								},
								"optional": false
							},
							{
								"name": "setPageIndex",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "Requireable",
									"parameters": [
										{
											"kind": "Named",
											"name": "any",
											"id": 1
										}
									],
									"id": 51,
									"importedFrom": "react"
								},
								"optional": false
							}
						]
					},
					"value": "{\n  pages: PropTypes.array,\n  currentPage: PropTypes.number,\n  canAdvance: PropTypes.bool,\n  canFinish: PropTypes.bool,\n  canReverse: PropTypes.bool,\n  setPageIndex: PropTypes.func,\n}"
				},
				"1": {
					"id": "1",
					"kind": "Type",
					"exportedIn": [],
					"name": "Context",
					"documentation": "The context that is avalible inside a stepper and is\nconsumed by the various UI components",
					"type": {
						"kind": "Object",
						"properties": [
							{
								"name": "pages",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "Array",
									"parameters": [
										{
											"kind": "Named",
											"name": "PageConfig",
											"id": 55
										}
									],
									"id": 56,
									"importedFrom": "lib es2016"
								},
								"optional": false
							},
							{
								"name": "currentPage",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "number",
									"id": 9
								},
								"optional": false
							},
							{
								"name": "canAdvance",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "boolean",
									"id": 12
								},
								"optional": false
							},
							{
								"name": "canFinish",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "boolean",
									"id": 12
								},
								"optional": false
							},
							{
								"name": "canReverse",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "boolean",
									"id": 12
								},
								"optional": false
							},
							{
								"name": "setPageIndex",
								"documentation": "",
								"type": {
									"kind": "Function",
									"parameters": [
										{
											"name": "index",
											"documentation": "",
											"type": {
												"kind": "Named",
												"name": "number",
												"id": 9
											},
											"optional": false
										}
									],
									"returnType": {
										"kind": "Named",
										"name": "void",
										"id": 14
									}
								},
								"optional": false
							}
						]
					}
				},
				"2": {
					"id": "2",
					"kind": "Type",
					"exportedIn": [],
					"name": "Awaitable",
					"documentation": "",
					"type": {
						"kind": "Union",
						"types": [
							{
								"kind": "Named",
								"name": "T",
								"id": 61
							},
							{
								"kind": "Named",
								"name": "Promise",
								"parameters": [
									{
										"kind": "Named",
										"name": "T",
										"id": 61
									}
								],
								"id": 62,
								"importedFrom": "lib es2015"
							}
						]
					}
				},
				"3": {
					"id": "3",
					"kind": "Type",
					"exportedIn": [],
					"name": "Status",
					"documentation": "The allowed page statuses",
					"type": {
						"kind": "Union",
						"types": [
							{
								"kind": "StringLiteral",
								"value": "done"
							},
							{
								"kind": "StringLiteral",
								"value": "alert"
							}
						]
					}
				},
				"4": {
					"id": "4",
					"kind": "Type",
					"exportedIn": [],
					"name": "PageConfig",
					"documentation": "A page in the stepper",
					"type": {
						"kind": "Object",
						"properties": [
							{
								"name": "title",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "string",
									"id": 8
								},
								"optional": true
							},
							{
								"name": "subTitle",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "string",
									"id": 8
								},
								"optional": true
							},
							{
								"name": "status",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "Status",
									"id": 68
								},
								"optional": true
							},
							{
								"name": "onEnter",
								"documentation": "Callback when the page is about to be set as active.\n\nIf a Promise is returned, it will be awaited before the page is actived.\nThis is not called when the stepper is first rendered.",
								"type": {
									"kind": "Function",
									"parameters": [
										{
											"name": "previousIndex",
											"documentation": "",
											"type": {
												"kind": "Named",
												"name": "number",
												"id": 9
											},
											"optional": false
										}
									],
									"returnType": {
										"kind": "Named",
										"name": "Awaitable",
										"parameters": [
											{
												"kind": "Named",
												"name": "void",
												"id": 14
											}
										],
										"id": 63
									}
								},
								"optional": true
							},
							{
								"name": "onLeave",
								"documentation": "Callback when the page is about the be left.\n\nIf a Promise is returned, it will be awaited before the next page is actived.\nIf false or a promise that resolves to false is returned the navigation is aborted.",
								"type": {
									"kind": "Function",
									"parameters": [
										{
											"name": "nextIndex",
											"documentation": "",
											"type": {
												"kind": "Named",
												"name": "number",
												"id": 9
											},
											"optional": false
										}
									],
									"returnType": {
										"kind": "Named",
										"name": "Awaitable",
										"parameters": [
											{
												"kind": "Union",
												"types": [
													{
														"kind": "Named",
														"name": "boolean"
													},
													{
														"kind": "Named",
														"name": "void",
														"id": 14
													}
												]
											}
										],
										"id": 63
									}
								},
								"optional": true
							},
							{
								"name": "onAdvance",
								"documentation": "Callback when the page is about the be left for a subsequent page.\n\nIf a Promise is returned, it will be awaited before the next page is actived.\nIf false or a promise that resolves to false is returned the navigation is aborted.",
								"type": {
									"kind": "Function",
									"parameters": [
										{
											"name": "nextIndex",
											"documentation": "",
											"type": {
												"kind": "Named",
												"name": "number",
												"id": 9
											},
											"optional": false
										}
									],
									"returnType": {
										"kind": "Named",
										"name": "Awaitable",
										"parameters": [
											{
												"kind": "Union",
												"types": [
													{
														"kind": "Named",
														"name": "boolean"
													},
													{
														"kind": "Named",
														"name": "void",
														"id": 14
													}
												]
											}
										],
										"id": 63
									}
								},
								"optional": true
							},
							{
								"name": "onReverse",
								"documentation": "Callback when the page is about the be left for a preceding page.\n\nIf a Promise is returned, it will be awaited before the next page is actived.\nIf false or a promise that resolves to false is returned the navigation is aborted.",
								"type": {
									"kind": "Function",
									"parameters": [
										{
											"name": "nextIndex",
											"documentation": "",
											"type": {
												"kind": "Named",
												"name": "number",
												"id": 9
											},
											"optional": false
										}
									],
									"returnType": {
										"kind": "Named",
										"name": "Awaitable",
										"parameters": [
											{
												"kind": "Union",
												"types": [
													{
														"kind": "Named",
														"name": "boolean"
													},
													{
														"kind": "Named",
														"name": "void",
														"id": 14
													}
												]
											}
										],
										"id": 63
									}
								},
								"optional": true
							},
							{
								"name": "canAdvance",
								"documentation": "Controls whenever the page is allow to be left for a subsequent page.",
								"type": {
									"kind": "Function",
									"parameters": [],
									"returnType": {
										"kind": "Named",
										"name": "boolean",
										"id": 12
									}
								},
								"optional": true
							},
							{
								"name": "canReverse",
								"documentation": "Controls whenever the page is allow to be left for a preceding page.",
								"type": {
									"kind": "Function",
									"parameters": [],
									"returnType": {
										"kind": "Named",
										"name": "boolean",
										"id": 12
									}
								},
								"optional": true
							},
							{
								"name": "render",
								"documentation": "A function to render when this page is active, takes precedence over\ncomponent if both is set.",
								"type": {
									"kind": "Function",
									"parameters": [],
									"returnType": {
										"kind": "Named",
										"name": "ReactElement",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 1
											}
										],
										"id": 81,
										"importedFrom": "react"
									}
								},
								"optional": true
							},
							{
								"name": "component",
								"documentation": "The component to render when this page is active. Either component or\nrender must be specified.",
								"type": {
									"kind": "Named",
									"name": "ReactType",
									"id": 90,
									"importedFrom": "react"
								},
								"optional": true
							}
						]
					}
				}
			},
			"reexports": []
		},
		"dist/src/with-stepper.js": {
			"name": "with-stepper",
			"srcPath": "src/with-stepper.tsx",
			"outPath": "dist/src/with-stepper.js",
			"declarations": {
				"5": {
					"id": "5",
					"kind": "Function",
					"exportedIn": [
						{
							"path": "dist/src/index.js",
							"name": "withStepper"
						}
					],
					"name": "withStepper",
					"documentation": "A HOC to inject the stepperContext as properties",
					"parameters": [
						{
							"name": "WrappedComponent",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "any",
								"id": 1
							},
							"optional": false
						}
					],
					"returnType": {
						"kind": "Named",
						"name": "any",
						"id": 3
					}
				}
			},
			"reexports": []
		},
		"dist/src/buttons.js": {
			"name": "buttons",
			"srcPath": "src/buttons.tsx",
			"outPath": "dist/src/buttons.js",
			"declarations": {
				"6": {
					"id": "6",
					"kind": "Type",
					"exportedIn": [
						{
							"path": "dist/src/index.js",
							"name": "AdvanceButtonProps"
						}
					],
					"name": "AdvanceButtonProps",
					"documentation": "",
					"type": {
						"kind": "Object",
						"properties": [
							{
								"name": "component",
								"documentation": "The component to render, it defaults to a browser <button> element.",
								"type": {
									"kind": "Named",
									"name": "ReactType",
									"id": 90,
									"importedFrom": "react"
								},
								"optional": true
							},
							{
								"name": "onFinish",
								"documentation": "Callback when the button is used to finish the stepper",
								"type": {
									"kind": "Function",
									"parameters": [],
									"returnType": {
										"kind": "Named",
										"name": "void",
										"id": 14
									}
								},
								"optional": true
							},
							{
								"name": "onNext",
								"documentation": "Callback when the button is used to go to the next page",
								"type": {
									"kind": "Function",
									"parameters": [],
									"returnType": {
										"kind": "Named",
										"name": "void",
										"id": 14
									}
								},
								"optional": true
							},
							{
								"name": "finishLabel",
								"documentation": "A label to show instead of the children when the stepper\nis on the last page.",
								"type": {
									"kind": "Named",
									"name": "ReactChild",
									"id": 98,
									"importedFrom": "react"
								},
								"optional": true
							}
						]
					}
				},
				"7": {
					"id": "7",
					"kind": "Component",
					"exportedIn": [
						{
							"path": "dist/src/index.js",
							"name": "AdvanceButton"
						}
					],
					"name": "AdvanceButton",
					"documentation": "Renders a button to go to the next step\n\n### Usage\n```\n<AdvanceButton>\n   Next\n</AdvanceButton>\n```",
					"properties": [
						{
							"name": "component",
							"documentation": "The component to render, it defaults to a browser <button> element.",
							"type": {
								"kind": "Named",
								"name": "ReactType",
								"id": 90,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onFinish",
							"documentation": "Callback when the button is used to finish the stepper",
							"type": {
								"kind": "Function",
								"parameters": [],
								"returnType": {
									"kind": "Named",
									"name": "void",
									"id": 14
								}
							},
							"optional": true
						},
						{
							"name": "onNext",
							"documentation": "Callback when the button is used to go to the next page",
							"type": {
								"kind": "Function",
								"parameters": [],
								"returnType": {
									"kind": "Named",
									"name": "void",
									"id": 14
								}
							},
							"optional": true
						},
						{
							"name": "finishLabel",
							"documentation": "A label to show instead of the children when the stepper\nis on the last page.",
							"type": {
								"kind": "Named",
								"name": "ReactChild",
								"id": 98,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "children",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "dangerouslySetInnerHTML",
							"documentation": "",
							"type": {
								"kind": "Object",
								"properties": [
									{
										"name": "___html",
										"documentation": "",
										"type": {
											"kind": "Named",
											"name": "string",
											"id": 8
										},
										"optional": false
									}
								]
							},
							"optional": true
						},
						{
							"name": "onCopy",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "ClipboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 126,
										"importedFrom": "react"
									}
								],
								"id": 127,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCopyCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "ClipboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 126,
										"importedFrom": "react"
									}
								],
								"id": 127,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCut",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "ClipboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 126,
										"importedFrom": "react"
									}
								],
								"id": 127,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCutCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "ClipboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 126,
										"importedFrom": "react"
									}
								],
								"id": 127,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPaste",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "ClipboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 126,
										"importedFrom": "react"
									}
								],
								"id": 127,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPasteCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "ClipboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 126,
										"importedFrom": "react"
									}
								],
								"id": 127,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCompositionEnd",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "CompositionEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 136,
										"importedFrom": "react"
									}
								],
								"id": 137,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCompositionEndCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "CompositionEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 136,
										"importedFrom": "react"
									}
								],
								"id": 137,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCompositionStart",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "CompositionEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 136,
										"importedFrom": "react"
									}
								],
								"id": 137,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCompositionStartCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "CompositionEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 136,
										"importedFrom": "react"
									}
								],
								"id": 137,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCompositionUpdate",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "CompositionEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 136,
										"importedFrom": "react"
									}
								],
								"id": 137,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCompositionUpdateCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "CompositionEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 136,
										"importedFrom": "react"
									}
								],
								"id": 137,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onFocus",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FocusEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 146,
										"importedFrom": "react"
									}
								],
								"id": 147,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onFocusCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FocusEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 146,
										"importedFrom": "react"
									}
								],
								"id": 147,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onBlur",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FocusEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 146,
										"importedFrom": "react"
									}
								],
								"id": 147,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onBlurCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FocusEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 146,
										"importedFrom": "react"
									}
								],
								"id": 147,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onChange",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onChangeCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onInput",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onInputCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onReset",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onResetCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSubmit",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSubmitCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoad",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoadCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onError",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onErrorCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onKeyDown",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "KeyboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 176,
										"importedFrom": "react"
									}
								],
								"id": 177,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onKeyDownCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "KeyboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 176,
										"importedFrom": "react"
									}
								],
								"id": 177,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onKeyPress",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "KeyboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 176,
										"importedFrom": "react"
									}
								],
								"id": 177,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onKeyPressCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "KeyboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 176,
										"importedFrom": "react"
									}
								],
								"id": 177,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onKeyUp",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "KeyboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 176,
										"importedFrom": "react"
									}
								],
								"id": 177,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onKeyUpCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "KeyboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 176,
										"importedFrom": "react"
									}
								],
								"id": 177,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAbort",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAbortCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCanPlay",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCanPlayCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCanPlayThrough",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCanPlayThroughCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDurationChange",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDurationChangeCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onEmptied",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onEmptiedCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onEncrypted",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onEncryptedCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onEnded",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onEndedCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoadedData",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoadedDataCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoadedMetadata",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoadedMetadataCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoadStart",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoadStartCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPause",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPauseCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPlay",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPlayCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPlaying",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPlayingCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onProgress",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onProgressCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onRateChange",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onRateChangeCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSeeked",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSeekedCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSeeking",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSeekingCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onStalled",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onStalledCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSuspend",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSuspendCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTimeUpdate",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTimeUpdateCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onVolumeChange",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onVolumeChangeCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onWaiting",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onWaitingCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onClick",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onClickCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onContextMenu",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onContextMenuCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDoubleClick",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDoubleClickCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDrag",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragEnd",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragEndCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragEnter",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragEnterCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragExit",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragExitCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragLeave",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragLeaveCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragOver",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragOverCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragStart",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragStartCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDrop",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDropCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseDown",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseDownCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseEnter",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseLeave",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseMove",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseMoveCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseOut",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseOutCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseOver",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseOverCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseUp",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseUpCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSelect",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSelectCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchCancel",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchCancelCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchEnd",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchEndCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchMove",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchMoveCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchStart",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchStartCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onScroll",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "UIEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 216,
										"importedFrom": "react"
									}
								],
								"id": 217,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onScrollCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "UIEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 216,
										"importedFrom": "react"
									}
								],
								"id": 217,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onWheel",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "WheelEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 226,
										"importedFrom": "react"
									}
								],
								"id": 227,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onWheelCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "WheelEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 226,
										"importedFrom": "react"
									}
								],
								"id": 227,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAnimationStart",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "AnimationEvent",
										"id": 228,
										"importedFrom": "react"
									}
								],
								"id": 230,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAnimationStartCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "AnimationEvent",
										"id": 228,
										"importedFrom": "react"
									}
								],
								"id": 230,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAnimationEnd",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "AnimationEvent",
										"id": 228,
										"importedFrom": "react"
									}
								],
								"id": 230,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAnimationEndCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "AnimationEvent",
										"id": 228,
										"importedFrom": "react"
									}
								],
								"id": 230,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAnimationIteration",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "AnimationEvent",
										"id": 228,
										"importedFrom": "react"
									}
								],
								"id": 230,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAnimationIterationCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "AnimationEvent",
										"id": 228,
										"importedFrom": "react"
									}
								],
								"id": 230,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTransitionEnd",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TransitionEvent",
										"id": 231,
										"importedFrom": "react"
									}
								],
								"id": 233,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTransitionEndCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TransitionEvent",
										"id": 231,
										"importedFrom": "react"
									}
								],
								"id": 233,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "children",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						}
					]
				},
				"8": {
					"id": "8",
					"kind": "Type",
					"exportedIn": [
						{
							"path": "dist/src/index.js",
							"name": "ReverseButtonProps"
						}
					],
					"name": "ReverseButtonProps",
					"documentation": "",
					"type": {
						"kind": "Object",
						"properties": [
							{
								"name": "component",
								"documentation": "The component to render, it defaults to a browser <button> element.",
								"type": {
									"kind": "Named",
									"name": "ReactType",
									"id": 90,
									"importedFrom": "react"
								},
								"optional": true
							},
							{
								"name": "onCancel",
								"documentation": "Callback when the button is used to cancel the stepper",
								"type": {
									"kind": "Function",
									"parameters": [],
									"returnType": {
										"kind": "Named",
										"name": "void",
										"id": 14
									}
								},
								"optional": true
							},
							{
								"name": "onPrevious",
								"documentation": "Callback when the button is used to go to the previous page",
								"type": {
									"kind": "Function",
									"parameters": [],
									"returnType": {
										"kind": "Named",
										"name": "void",
										"id": 14
									}
								},
								"optional": true
							},
							{
								"name": "cancelLabel",
								"documentation": "A label to show instead of the children when the stepper\nis on the first page.",
								"type": {
									"kind": "Named",
									"name": "ReactChild",
									"id": 98,
									"importedFrom": "react"
								},
								"optional": true
							}
						]
					}
				},
				"9": {
					"id": "9",
					"kind": "Component",
					"exportedIn": [
						{
							"path": "dist/src/index.js",
							"name": "ReverseButton"
						}
					],
					"name": "ReverseButton",
					"documentation": "Renders a button to go to the previous step\n\n### Usage\n```\n<ReverseButton>\n   Back\n</ReverseButton>\n```",
					"properties": [
						{
							"name": "component",
							"documentation": "The component to render, it defaults to a browser <button> element.",
							"type": {
								"kind": "Named",
								"name": "ReactType",
								"id": 90,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCancel",
							"documentation": "Callback when the button is used to cancel the stepper",
							"type": {
								"kind": "Function",
								"parameters": [],
								"returnType": {
									"kind": "Named",
									"name": "void",
									"id": 14
								}
							},
							"optional": true
						},
						{
							"name": "onPrevious",
							"documentation": "Callback when the button is used to go to the previous page",
							"type": {
								"kind": "Function",
								"parameters": [],
								"returnType": {
									"kind": "Named",
									"name": "void",
									"id": 14
								}
							},
							"optional": true
						},
						{
							"name": "cancelLabel",
							"documentation": "A label to show instead of the children when the stepper\nis on the first page.",
							"type": {
								"kind": "Named",
								"name": "ReactChild",
								"id": 98,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "children",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "dangerouslySetInnerHTML",
							"documentation": "",
							"type": {
								"kind": "Object",
								"properties": [
									{
										"name": "___html",
										"documentation": "",
										"type": {
											"kind": "Named",
											"name": "string",
											"id": 8
										},
										"optional": false
									}
								]
							},
							"optional": true
						},
						{
							"name": "onCopy",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "ClipboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 126,
										"importedFrom": "react"
									}
								],
								"id": 127,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCopyCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "ClipboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 126,
										"importedFrom": "react"
									}
								],
								"id": 127,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCut",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "ClipboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 126,
										"importedFrom": "react"
									}
								],
								"id": 127,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCutCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "ClipboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 126,
										"importedFrom": "react"
									}
								],
								"id": 127,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPaste",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "ClipboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 126,
										"importedFrom": "react"
									}
								],
								"id": 127,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPasteCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "ClipboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 126,
										"importedFrom": "react"
									}
								],
								"id": 127,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCompositionEnd",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "CompositionEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 136,
										"importedFrom": "react"
									}
								],
								"id": 137,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCompositionEndCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "CompositionEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 136,
										"importedFrom": "react"
									}
								],
								"id": 137,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCompositionStart",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "CompositionEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 136,
										"importedFrom": "react"
									}
								],
								"id": 137,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCompositionStartCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "CompositionEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 136,
										"importedFrom": "react"
									}
								],
								"id": 137,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCompositionUpdate",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "CompositionEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 136,
										"importedFrom": "react"
									}
								],
								"id": 137,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCompositionUpdateCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "CompositionEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 136,
										"importedFrom": "react"
									}
								],
								"id": 137,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onFocus",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FocusEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 146,
										"importedFrom": "react"
									}
								],
								"id": 147,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onFocusCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FocusEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 146,
										"importedFrom": "react"
									}
								],
								"id": 147,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onBlur",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FocusEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 146,
										"importedFrom": "react"
									}
								],
								"id": 147,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onBlurCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FocusEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 146,
										"importedFrom": "react"
									}
								],
								"id": 147,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onChange",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onChangeCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onInput",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onInputCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onReset",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onResetCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSubmit",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSubmitCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "FormEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 156,
										"importedFrom": "react"
									}
								],
								"id": 157,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoad",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoadCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onError",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onErrorCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onKeyDown",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "KeyboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 176,
										"importedFrom": "react"
									}
								],
								"id": 177,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onKeyDownCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "KeyboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 176,
										"importedFrom": "react"
									}
								],
								"id": 177,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onKeyPress",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "KeyboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 176,
										"importedFrom": "react"
									}
								],
								"id": 177,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onKeyPressCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "KeyboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 176,
										"importedFrom": "react"
									}
								],
								"id": 177,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onKeyUp",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "KeyboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 176,
										"importedFrom": "react"
									}
								],
								"id": 177,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onKeyUpCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "KeyboardEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 176,
										"importedFrom": "react"
									}
								],
								"id": 177,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAbort",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAbortCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCanPlay",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCanPlayCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCanPlayThrough",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCanPlayThroughCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDurationChange",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDurationChangeCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onEmptied",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onEmptiedCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onEncrypted",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onEncryptedCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onEnded",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onEndedCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoadedData",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoadedDataCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoadedMetadata",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoadedMetadataCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoadStart",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onLoadStartCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPause",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPauseCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPlay",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPlayCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPlaying",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onPlayingCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onProgress",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onProgressCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onRateChange",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onRateChangeCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSeeked",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSeekedCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSeeking",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSeekingCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onStalled",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onStalledCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSuspend",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSuspendCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTimeUpdate",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTimeUpdateCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onVolumeChange",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onVolumeChangeCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onWaiting",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onWaitingCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onClick",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onClickCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onContextMenu",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onContextMenuCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDoubleClick",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDoubleClickCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDrag",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragEnd",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragEndCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragEnter",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragEnterCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragExit",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragExitCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragLeave",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragLeaveCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragOver",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragOverCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragStart",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDragStartCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDrop",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onDropCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "DragEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 196,
										"importedFrom": "react"
									}
								],
								"id": 197,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseDown",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseDownCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseEnter",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseLeave",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseMove",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseMoveCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseOut",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseOutCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseOver",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseOverCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseUp",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onMouseUpCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "MouseEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 186,
										"importedFrom": "react"
									}
								],
								"id": 187,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSelect",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onSelectCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "SyntheticEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 166,
										"importedFrom": "react"
									}
								],
								"id": 167,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchCancel",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchCancelCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchEnd",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchEndCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchMove",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchMoveCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchStart",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTouchStartCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TouchEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 206,
										"importedFrom": "react"
									}
								],
								"id": 207,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onScroll",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "UIEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 216,
										"importedFrom": "react"
									}
								],
								"id": 217,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onScrollCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "UIEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 216,
										"importedFrom": "react"
									}
								],
								"id": 217,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onWheel",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "WheelEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 226,
										"importedFrom": "react"
									}
								],
								"id": 227,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onWheelCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "WheelEvent",
										"parameters": [
											{
												"kind": "Named",
												"name": "any",
												"id": 3
											}
										],
										"id": 226,
										"importedFrom": "react"
									}
								],
								"id": 227,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAnimationStart",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "AnimationEvent",
										"id": 228,
										"importedFrom": "react"
									}
								],
								"id": 230,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAnimationStartCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "AnimationEvent",
										"id": 228,
										"importedFrom": "react"
									}
								],
								"id": 230,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAnimationEnd",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "AnimationEvent",
										"id": 228,
										"importedFrom": "react"
									}
								],
								"id": 230,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAnimationEndCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "AnimationEvent",
										"id": 228,
										"importedFrom": "react"
									}
								],
								"id": 230,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAnimationIteration",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "AnimationEvent",
										"id": 228,
										"importedFrom": "react"
									}
								],
								"id": 230,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onAnimationIterationCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "AnimationEvent",
										"id": 228,
										"importedFrom": "react"
									}
								],
								"id": 230,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTransitionEnd",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TransitionEvent",
										"id": 231,
										"importedFrom": "react"
									}
								],
								"id": 233,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onTransitionEndCapture",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "EventHandler",
								"parameters": [
									{
										"kind": "Named",
										"name": "TransitionEvent",
										"id": 231,
										"importedFrom": "react"
									}
								],
								"id": 233,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "children",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						}
					]
				}
			},
			"reexports": []
		},
		"dist/src/utils.js": {
			"name": "utils",
			"srcPath": "src/utils.tsx",
			"outPath": "dist/src/utils.js",
			"declarations": {
				"10": {
					"id": "10",
					"kind": "Variable",
					"exportedIn": [],
					"name": "defaultActiveColor",
					"documentation": "",
					"type": {
						"kind": "StringLiteral",
						"value": "#3f51b5"
					},
					"value": "'#3f51b5'"
				},
				"11": {
					"id": "11",
					"kind": "Variable",
					"exportedIn": [],
					"name": "defaultAlertColor",
					"documentation": "",
					"type": {
						"kind": "StringLiteral",
						"value": "#f44336"
					},
					"value": "'#f44336'"
				},
				"12": {
					"id": "12",
					"kind": "Variable",
					"exportedIn": [],
					"name": "defaultInactiveColor",
					"documentation": "",
					"type": {
						"kind": "StringLiteral",
						"value": "#bdbdbd"
					},
					"value": "'#bdbdbd'"
				},
				"13": {
					"id": "13",
					"kind": "Type",
					"exportedIn": [],
					"name": "CircleProps",
					"documentation": "",
					"type": {
						"kind": "Object",
						"properties": [
							{
								"name": "color",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "string",
									"id": 8
								},
								"optional": false
							},
							{
								"name": "size",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "number",
									"id": 9
								},
								"optional": false
							},
							{
								"name": "margin",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "number",
									"id": 9
								},
								"optional": true
							},
							{
								"name": "children",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "ReactChild",
									"id": 98,
									"importedFrom": "react"
								},
								"optional": true
							},
							{
								"name": "style",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "CSSProperties",
									"id": 248,
									"importedFrom": "react"
								},
								"optional": true
							}
						]
					}
				},
				"14": {
					"id": "14",
					"kind": "Component",
					"exportedIn": [],
					"name": "Circle",
					"documentation": "A simple circle, used for step icons and by the dot tracker.",
					"properties": [
						{
							"name": "color",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": false
						},
						{
							"name": "size",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "number",
								"id": 9
							},
							"optional": false
						},
						{
							"name": "margin",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "number",
								"id": 9
							},
							"optional": true
						},
						{
							"name": "children",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "ReactChild",
								"id": 98,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "style",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "CSSProperties",
								"id": 248,
								"importedFrom": "react"
							},
							"optional": true
						}
					]
				},
				"15": {
					"id": "15",
					"kind": "Function",
					"exportedIn": [],
					"name": "onKeyboardClick",
					"documentation": "A function to filter keyboard events to spacebar and Enter",
					"parameters": [
						{
							"name": "fn",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "any",
								"id": 1
							},
							"optional": false
						}
					],
					"returnType": {
						"kind": "Function",
						"parameters": [
							{
								"name": "e",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "KeyboardEvent",
									"parameters": [
										{
											"kind": "Named",
											"name": "any",
											"id": 1
										}
									],
									"id": 277,
									"importedFrom": "react"
								},
								"optional": false
							}
						],
						"returnType": {
							"kind": "Named",
							"name": "any",
							"id": 1
						}
					}
				},
				"16": {
					"id": "16",
					"kind": "Component",
					"exportedIn": [],
					"name": "ClickableRow",
					"documentation": "A flexbox row that is focusable and clickable like a button",
					"properties": [
						{
							"name": "onClick",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "any",
								"id": 3
							},
							"optional": false
						},
						{
							"name": "disabled",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "any",
								"id": 3
							},
							"optional": false
						},
						{
							"name": "style",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "any",
								"id": 3
							},
							"optional": false
						}
					]
				},
				"17": {
					"id": "17",
					"kind": "Component",
					"exportedIn": [],
					"name": "VerticalLine",
					"documentation": "A simple vertical line, used for constructing the vertical stepper",
					"properties": []
				}
			},
			"reexports": []
		},
		"dist/src/dot-tracker.js": {
			"name": "dot-tracker",
			"srcPath": "src/dot-tracker.tsx",
			"outPath": "dist/src/dot-tracker.js",
			"declarations": {
				"18": {
					"id": "18",
					"kind": "Component",
					"exportedIn": [
						{
							"path": "dist/src/index.js",
							"name": "DotTracker"
						}
					],
					"name": "DotTracker",
					"documentation": "A component for tracking the current and total pages\nusing dots.\n\n### Usage\n```\n<DotTracker />\n```",
					"properties": [
						{
							"name": "activeColor",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "inactiveColor",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "style",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "CSSProperties",
								"id": 248,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "children",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						}
					]
				}
			},
			"reexports": []
		},
		"dist/src/step-title.js": {
			"name": "step-title",
			"srcPath": "src/step-title.tsx",
			"outPath": "dist/src/step-title.js",
			"declarations": {
				"19": {
					"id": "19",
					"kind": "Component",
					"exportedIn": [
						{
							"path": "dist/src/index.js",
							"name": "StepTitle"
						}
					],
					"name": "StepTitle",
					"documentation": "A component that display the title of the active page.\n\n### Usage\n```\n<StepTitle />\n```",
					"properties": [
						{
							"name": "style",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "CSSProperties",
								"id": 248,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "children",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						}
					]
				}
			},
			"reexports": []
		},
		"dist/src/stepper.js": {
			"name": "stepper",
			"srcPath": "src/stepper.tsx",
			"outPath": "dist/src/stepper.js",
			"declarations": {
				"20": {
					"id": "20",
					"kind": "Type",
					"exportedIn": [],
					"name": "Props",
					"documentation": "",
					"type": {
						"kind": "Object",
						"properties": [
							{
								"name": "index",
								"documentation": "The page index to set as active page",
								"type": {
									"kind": "Named",
									"name": "number",
									"id": 9
								},
								"optional": true
							},
							{
								"name": "onChange",
								"documentation": "Called when the page changes. If this is passed, the Stepper\nbecomes controlled and will expect the parent to maintain the state and update\nthe index property appropriately.",
								"type": {
									"kind": "Function",
									"parameters": [
										{
											"name": "index",
											"documentation": "",
											"type": {
												"kind": "Named",
												"name": "number",
												"id": 9
											},
											"optional": false
										}
									],
									"returnType": {
										"kind": "Named",
										"name": "void",
										"id": 14
									}
								},
								"optional": true
							},
							{
								"name": "pages",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "Array",
									"parameters": [
										{
											"kind": "Named",
											"name": "PageConfig",
											"id": 55
										}
									],
									"id": 56,
									"importedFrom": "lib es2016"
								},
								"optional": false
							},
							{
								"name": "allowJumpBack",
								"documentation": "Allow reversing more than one step at a time",
								"type": {
									"kind": "Named",
									"name": "boolean",
									"id": 12
								},
								"optional": true
							},
							{
								"name": "allowJumpAhead",
								"documentation": "Allow advancing more than one step at a time",
								"type": {
									"kind": "Named",
									"name": "boolean",
									"id": 12
								},
								"optional": true
							}
						]
					}
				},
				"21": {
					"id": "21",
					"kind": "Type",
					"exportedIn": [],
					"name": "State",
					"documentation": "",
					"type": {
						"kind": "Object",
						"properties": [
							{
								"name": "currentPage",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "number",
									"id": 9
								},
								"optional": true
							}
						]
					}
				},
				"22": {
					"id": "22",
					"kind": "Component",
					"exportedIn": [
						{
							"path": "dist/src/index.js",
							"name": "Stepper"
						}
					],
					"name": "Stepper",
					"documentation": "The component where a stepper is configured and holds all state\nand logic for navigating a stepper.\n\nIt does not render any UI by itself and must be accompanied by\nUI components like the DotTracker, Advance and Reverse Buttons or others.\n\n### Usage\n```\n<Stepper pages={[{component: PageOne}, {component: PageTwo}]}>\n  <StepperView />\n  <Row>\n    <ReverseButton>Back</ReverseButton>\n    <DotTracker />\n    <AdvanceButton>Next</AdvanceButton>\n  </Row>\n</Stepper>\n```",
					"properties": [
						{
							"name": "children",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "index",
							"documentation": "The page index to set as active page",
							"type": {
								"kind": "Named",
								"name": "number",
								"id": 9
							},
							"optional": true
						},
						{
							"name": "onChange",
							"documentation": "Called when the page changes. If this is passed, the Stepper\nbecomes controlled and will expect the parent to maintain the state and update\nthe index property appropriately.",
							"type": {
								"kind": "Function",
								"parameters": [
									{
										"name": "index",
										"documentation": "",
										"type": {
											"kind": "Named",
											"name": "number",
											"id": 9
										},
										"optional": false
									}
								],
								"returnType": {
									"kind": "Named",
									"name": "void",
									"id": 14
								}
							},
							"optional": true
						},
						{
							"name": "pages",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Array",
								"parameters": [
									{
										"kind": "Named",
										"name": "PageConfig",
										"id": 55
									}
								],
								"id": 56,
								"importedFrom": "lib es2016"
							},
							"optional": false
						},
						{
							"name": "allowJumpBack",
							"documentation": "Allow reversing more than one step at a time",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "allowJumpAhead",
							"documentation": "Allow advancing more than one step at a time",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						}
					]
				}
			},
			"reexports": []
		},
		"dist/src/stepper-view.js": {
			"name": "stepper-view",
			"srcPath": "src/stepper-view.tsx",
			"outPath": "dist/src/stepper-view.js",
			"declarations": {
				"23": {
					"id": "23",
					"kind": "Component",
					"exportedIn": [
						{
							"path": "dist/src/index.js",
							"name": "StepperView"
						}
					],
					"name": "StepperView",
					"documentation": "Renders the active page in the stepper",
					"properties": [
						{
							"name": "children",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						}
					]
				}
			},
			"reexports": []
		},
		"dist/src/text-tracker.js": {
			"name": "text-tracker",
			"srcPath": "src/text-tracker.tsx",
			"outPath": "dist/src/text-tracker.js",
			"declarations": {
				"24": {
					"id": "24",
					"kind": "Component",
					"exportedIn": [
						{
							"path": "dist/src/index.js",
							"name": "TextTracker"
						}
					],
					"name": "TextTracker",
					"documentation": "A component for tracking the current and total pages\nusing a text.\n\n### Usage\n```\n<TextTracker />\n```\n\n### Options\nThe default behavior is to render a tect in the format `Step 1 of 2`.\nTo render in a different format, pass a function in the generateText property\nthat takes the current and total number of pages as arguments and returns\nthe text to be rendered.\n\nFor example\n```\n(current, total) => `${current + 1} / ${total}`\n```\nwill render `1 / 2`. Note that the current page is zero based.",
					"properties": [
						{
							"name": "generateText",
							"documentation": "",
							"type": {
								"kind": "Function",
								"parameters": [
									{
										"name": "current",
										"documentation": "",
										"type": {
											"kind": "Named",
											"name": "number",
											"id": 9
										},
										"optional": false
									},
									{
										"name": "total",
										"documentation": "",
										"type": {
											"kind": "Named",
											"name": "number",
											"id": 9
										},
										"optional": false
									}
								],
								"returnType": {
									"kind": "Named",
									"name": "string",
									"id": 8
								}
							},
							"optional": true
						},
						{
							"name": "style",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "CSSProperties",
								"id": 248,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "children",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						}
					]
				}
			},
			"reexports": []
		},
		"dist/src/index.js": {
			"name": "index",
			"srcPath": "src/index.tsx",
			"outPath": "dist/src/index.js",
			"declarations": {},
			"reexports": [
				{
					"name": "DotTracker",
					"srcName": "DotTracker",
					"path": "dist/src/dot-tracker.js",
					"id": "18"
				},
				{
					"name": "StepTitle",
					"srcName": "StepTitle",
					"path": "dist/src/step-title.js",
					"id": "19"
				},
				{
					"name": "Stepper",
					"srcName": "Stepper",
					"path": "dist/src/stepper.js",
					"id": "22"
				},
				{
					"name": "StepperView",
					"srcName": "StepperView",
					"path": "dist/src/stepper-view.js",
					"id": "23"
				},
				{
					"name": "TextTracker",
					"srcName": "TextTracker",
					"path": "dist/src/text-tracker.js",
					"id": "24"
				},
				{
					"name": "withStepper",
					"srcName": "withStepper",
					"path": "dist/src/with-stepper.js",
					"id": "5"
				},
				{
					"name": "AdvanceButtonProps",
					"srcName": "AdvanceButtonProps",
					"path": "dist/src/buttons.js",
					"id": "6"
				},
				{
					"name": "AdvanceButton",
					"srcName": "AdvanceButton",
					"path": "dist/src/buttons.js",
					"id": "7"
				},
				{
					"name": "ReverseButtonProps",
					"srcName": "ReverseButtonProps",
					"path": "dist/src/buttons.js",
					"id": "8"
				},
				{
					"name": "ReverseButton",
					"srcName": "ReverseButton",
					"path": "dist/src/buttons.js",
					"id": "9"
				}
			]
		},
		"dist/src/react-toolbox/buttons.js": {
			"name": "buttons",
			"srcPath": "src/react-toolbox/buttons.tsx",
			"outPath": "dist/src/react-toolbox/buttons.js",
			"declarations": {
				"25": {
					"id": "25",
					"kind": "Component",
					"exportedIn": [
						{
							"path": "dist/src/react-toolbox/index.js",
							"name": "AdvanceButton"
						}
					],
					"name": "AdvanceButton",
					"documentation": "Renders a react-toolbox Button to go to the next step\n\nThis is just a wrapper around the basic [AdvanceButton](/#/docs/dist/src/buttons.js/component.AdvanceButton)\nbut with Button from react-toolbox passed in the component property.\n\n### Usage\n```\n<AdvanceButton>\n   Next\n</AdvanceButton>\n```",
					"properties": [
						{
							"name": "component",
							"documentation": "The component to render, it defaults to a browser <button> element.",
							"type": {
								"kind": "Named",
								"name": "ReactType",
								"id": 90,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onFinish",
							"documentation": "Callback when the button is used to finish the stepper",
							"type": {
								"kind": "Function",
								"parameters": [],
								"returnType": {
									"kind": "Named",
									"name": "void",
									"id": 14
								}
							},
							"optional": true
						},
						{
							"name": "onNext",
							"documentation": "Callback when the button is used to go to the next page",
							"type": {
								"kind": "Function",
								"parameters": [],
								"returnType": {
									"kind": "Named",
									"name": "void",
									"id": 14
								}
							},
							"optional": true
						},
						{
							"name": "finishLabel",
							"documentation": "A label to show instead of the children when the stepper\nis on the last page.",
							"type": {
								"kind": "Named",
								"name": "ReactChild",
								"id": 98,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "flat",
							"documentation": "If true, the button will have a flat look.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "floating",
							"documentation": "If true, the button will have a floating look.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "href",
							"documentation": "Creates a link for the button.",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "label",
							"documentation": "The text string to use for the name of the button.",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "mini",
							"documentation": "To be used with floating button. If true, the button will be smaller.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "raised",
							"documentation": "If true, the button will have a raised look.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "theme",
							"documentation": "Classnames object defining the component style.",
							"type": {
								"kind": "Named",
								"name": "ButtonTheme",
								"id": 454
							},
							"optional": true
						},
						{
							"name": "accent",
							"documentation": "Indicates if the button should have accent color.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "children",
							"documentation": "Children to pass through the component.",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "disabled",
							"documentation": "If true, component will be disabled.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "icon",
							"documentation": "Value of the icon (See Font Icon Component).",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "inverse",
							"documentation": "If true, the neutral colors are inverted. Useful to put a button over a dark background.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "neutral",
							"documentation": "Set it to false if you don't want the neutral styles to be included.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "onMouseLeave",
							"documentation": "Fires after the mouse leaves the Component.",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onMouseUp",
							"documentation": "Fires after the mouse is released from the Component.",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "primary",
							"documentation": "Indicates if the button should have primary color.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "ripple",
							"documentation": "If true, component will have a ripple effect on click.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "type",
							"documentation": "Component root container type.",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "className",
							"documentation": "Set a class for the root component.",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "key",
							"documentation": "Key used to uniquely identify the element within an Array.",
							"type": {
								"kind": "Named",
								"name": "ReactText",
								"id": 97,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onClick",
							"documentation": "Callback called when the component is clicked.",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onMouseEnter",
							"documentation": "Callback called when the mouse enters the Component.",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onMouseDown",
							"documentation": "Callback called when the mouse press the Component.",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onContextMenu",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDoubleClick",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDrag",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDragEnd",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDragEnter",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDragExit",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDragLeave",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDragOver",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDragStart",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDrop",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onMouseMove",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onMouseOut",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onMouseOver",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onTouchCancel",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onTouchEnd",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onTouchMove",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onTouchStart",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "style",
							"documentation": "Set inline style for the root component.",
							"type": {
								"kind": "Named",
								"name": "CSSProperties",
								"id": 248,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "children",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						}
					]
				},
				"26": {
					"id": "26",
					"kind": "Component",
					"exportedIn": [
						{
							"path": "dist/src/react-toolbox/index.js",
							"name": "ReverseButton"
						}
					],
					"name": "ReverseButton",
					"documentation": "Renders a react-toolbox Button to go to the previous step\n\nThis is just a wrapper around the basic [ReverseButton](/#/docs/dist/src/buttons.js/component.ReverseButton)\nbut with Button from react-toolbox passed in the component property.\n\n### Usage\n```\n<ReverseButton>\n   Back\n</ReverseButton>\n```",
					"properties": [
						{
							"name": "component",
							"documentation": "The component to render, it defaults to a browser <button> element.",
							"type": {
								"kind": "Named",
								"name": "ReactType",
								"id": 90,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onCancel",
							"documentation": "Callback when the button is used to cancel the stepper",
							"type": {
								"kind": "Function",
								"parameters": [],
								"returnType": {
									"kind": "Named",
									"name": "void",
									"id": 14
								}
							},
							"optional": true
						},
						{
							"name": "onPrevious",
							"documentation": "Callback when the button is used to go to the previous page",
							"type": {
								"kind": "Function",
								"parameters": [],
								"returnType": {
									"kind": "Named",
									"name": "void",
									"id": 14
								}
							},
							"optional": true
						},
						{
							"name": "cancelLabel",
							"documentation": "A label to show instead of the children when the stepper\nis on the first page.",
							"type": {
								"kind": "Named",
								"name": "ReactChild",
								"id": 98,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "flat",
							"documentation": "If true, the button will have a flat look.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "floating",
							"documentation": "If true, the button will have a floating look.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "href",
							"documentation": "Creates a link for the button.",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "label",
							"documentation": "The text string to use for the name of the button.",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "mini",
							"documentation": "To be used with floating button. If true, the button will be smaller.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "raised",
							"documentation": "If true, the button will have a raised look.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "theme",
							"documentation": "Classnames object defining the component style.",
							"type": {
								"kind": "Named",
								"name": "ButtonTheme",
								"id": 454
							},
							"optional": true
						},
						{
							"name": "accent",
							"documentation": "Indicates if the button should have accent color.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "children",
							"documentation": "Children to pass through the component.",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "disabled",
							"documentation": "If true, component will be disabled.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "icon",
							"documentation": "Value of the icon (See Font Icon Component).",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "inverse",
							"documentation": "If true, the neutral colors are inverted. Useful to put a button over a dark background.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "neutral",
							"documentation": "Set it to false if you don't want the neutral styles to be included.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "onMouseLeave",
							"documentation": "Fires after the mouse leaves the Component.",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onMouseUp",
							"documentation": "Fires after the mouse is released from the Component.",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "primary",
							"documentation": "Indicates if the button should have primary color.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "ripple",
							"documentation": "If true, component will have a ripple effect on click.",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "type",
							"documentation": "Component root container type.",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "className",
							"documentation": "Set a class for the root component.",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "key",
							"documentation": "Key used to uniquely identify the element within an Array.",
							"type": {
								"kind": "Named",
								"name": "ReactText",
								"id": 97,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "onClick",
							"documentation": "Callback called when the component is clicked.",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onMouseEnter",
							"documentation": "Callback called when the mouse enters the Component.",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onMouseDown",
							"documentation": "Callback called when the mouse press the Component.",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onContextMenu",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDoubleClick",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDrag",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDragEnd",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDragEnter",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDragExit",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDragLeave",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDragOver",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDragStart",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onDrop",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onMouseMove",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onMouseOut",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onMouseOver",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onTouchCancel",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onTouchEnd",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onTouchMove",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "onTouchStart",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Function",
								"id": 29,
								"importedFrom": "lib es5"
							},
							"optional": true
						},
						{
							"name": "style",
							"documentation": "Set inline style for the root component.",
							"type": {
								"kind": "Named",
								"name": "CSSProperties",
								"id": 248,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "children",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						}
					]
				}
			},
			"reexports": []
		},
		"dist/src/react-toolbox/step-circle.js": {
			"name": "step-circle",
			"srcPath": "src/react-toolbox/step-circle.tsx",
			"outPath": "dist/src/react-toolbox/step-circle.js",
			"declarations": {
				"27": {
					"id": "27",
					"kind": "Type",
					"exportedIn": [],
					"name": "Props",
					"documentation": "",
					"type": {
						"kind": "Object",
						"properties": [
							{
								"name": "step",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "number",
									"id": 9
								},
								"optional": false
							},
							{
								"name": "active",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "boolean",
									"id": 12
								},
								"optional": true
							},
							{
								"name": "status",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "Status",
									"id": 68
								},
								"optional": true
							},
							{
								"name": "activeColor",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "string",
									"id": 8
								},
								"optional": true
							},
							{
								"name": "alertColor",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "string",
									"id": 8
								},
								"optional": true
							},
							{
								"name": "style",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "CSSProperties",
									"id": 248,
									"importedFrom": "react"
								},
								"optional": true
							}
						]
					}
				},
				"28": {
					"id": "28",
					"kind": "Component",
					"exportedIn": [],
					"name": "AlertIcon",
					"documentation": "An material warning icon to use for steps that needs the\nusers attention.",
					"properties": [
						{
							"name": "alertColor",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "any",
								"id": 3
							},
							"optional": true
						}
					]
				},
				"29": {
					"id": "29",
					"kind": "Component",
					"exportedIn": [],
					"name": "DoneIcon",
					"documentation": "A material check icon in a circle to use for steps that\nare completed.",
					"properties": [
						{
							"name": "activeColor",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "any",
								"id": 3
							},
							"optional": true
						}
					]
				},
				"30": {
					"id": "30",
					"kind": "Component",
					"exportedIn": [],
					"name": "StepNumber",
					"documentation": "A circle with the step number to use for most steps.",
					"properties": [
						{
							"name": "step",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "any",
								"id": 3
							},
							"optional": false
						},
						{
							"name": "active",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "any",
								"id": 3
							},
							"optional": false
						},
						{
							"name": "activeColor",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "any",
								"id": 3
							},
							"optional": true
						}
					]
				},
				"31": {
					"id": "31",
					"kind": "Component",
					"exportedIn": [],
					"name": "StepCircle",
					"documentation": "Renders the appropriate step icon for the current status.",
					"properties": [
						{
							"name": "step",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "number",
								"id": 9
							},
							"optional": false
						},
						{
							"name": "active",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": true
						},
						{
							"name": "status",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Status",
								"id": 68
							},
							"optional": true
						},
						{
							"name": "activeColor",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "alertColor",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "style",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "CSSProperties",
								"id": 248,
								"importedFrom": "react"
							},
							"optional": true
						}
					]
				}
			},
			"reexports": []
		},
		"dist/src/react-toolbox/step-header.js": {
			"name": "step-header",
			"srcPath": "src/react-toolbox/step-header.tsx",
			"outPath": "dist/src/react-toolbox/step-header.js",
			"declarations": {
				"32": {
					"id": "32",
					"kind": "Type",
					"exportedIn": [],
					"name": "Props",
					"documentation": "",
					"type": {
						"kind": "Object",
						"properties": [
							{
								"name": "step",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "number",
									"id": 9
								},
								"optional": false
							},
							{
								"name": "active",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "boolean",
									"id": 12
								},
								"optional": false
							},
							{
								"name": "page",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "PageConfig",
									"id": 55
								},
								"optional": false
							},
							{
								"name": "onClick",
								"documentation": "",
								"type": {
									"kind": "Function",
									"parameters": [
										{
											"name": "e",
											"documentation": "",
											"type": {
												"kind": "Named",
												"name": "any",
												"id": 3
											},
											"optional": false
										}
									],
									"returnType": {
										"kind": "Named",
										"name": "void",
										"id": 14
									}
								},
								"optional": true
							},
							{
								"name": "style",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "CSSProperties",
									"id": 248,
									"importedFrom": "react"
								},
								"optional": true
							},
							{
								"name": "activeColor",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "string",
									"id": 8
								},
								"optional": true
							},
							{
								"name": "alertColor",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "string",
									"id": 8
								},
								"optional": true
							}
						]
					}
				},
				"33": {
					"id": "33",
					"kind": "Component",
					"exportedIn": [],
					"name": "StepHeader",
					"documentation": "A step header after [material design](https://material.io/guidelines/components/steppers.html#steppers-specs)\nrenders a step icon and title. Used for building material design based steppers.",
					"properties": [
						{
							"name": "step",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "number",
								"id": 9
							},
							"optional": false
						},
						{
							"name": "active",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": false
						},
						{
							"name": "page",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "PageConfig",
								"id": 55
							},
							"optional": false
						},
						{
							"name": "onClick",
							"documentation": "",
							"type": {
								"kind": "Function",
								"parameters": [
									{
										"name": "e",
										"documentation": "",
										"type": {
											"kind": "Named",
											"name": "any",
											"id": 3
										},
										"optional": false
									}
								],
								"returnType": {
									"kind": "Named",
									"name": "void",
									"id": 14
								}
							},
							"optional": true
						},
						{
							"name": "style",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "CSSProperties",
								"id": 248,
								"importedFrom": "react"
							},
							"optional": true
						},
						{
							"name": "activeColor",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "alertColor",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						}
					]
				}
			},
			"reexports": []
		},
		"dist/src/react-toolbox/vertical-stepper.js": {
			"name": "vertical-stepper",
			"srcPath": "src/react-toolbox/vertical-stepper.tsx",
			"outPath": "dist/src/react-toolbox/vertical-stepper.js",
			"declarations": {
				"34": {
					"id": "34",
					"kind": "Type",
					"exportedIn": [],
					"name": "Props",
					"documentation": "",
					"type": {
						"kind": "Object",
						"properties": [
							{
								"name": "activeColor",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "string",
									"id": 8
								},
								"optional": true
							},
							{
								"name": "alertColor",
								"documentation": "",
								"type": {
									"kind": "Named",
									"name": "string",
									"id": 8
								},
								"optional": true
							}
						]
					}
				},
				"35": {
					"id": "35",
					"kind": "Component",
					"exportedIn": [],
					"name": "StatelessVerticalStepper",
					"documentation": "",
					"properties": [
						{
							"name": "activeColor",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "alertColor",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "pages",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "Array",
								"parameters": [
									{
										"kind": "Named",
										"name": "PageConfig",
										"id": 55
									}
								],
								"id": 56,
								"importedFrom": "lib es2016"
							},
							"optional": false
						},
						{
							"name": "currentPage",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "number",
								"id": 9
							},
							"optional": false
						},
						{
							"name": "canAdvance",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": false
						},
						{
							"name": "canFinish",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": false
						},
						{
							"name": "canReverse",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "boolean",
								"id": 12
							},
							"optional": false
						},
						{
							"name": "setPageIndex",
							"documentation": "",
							"type": {
								"kind": "Function",
								"parameters": [
									{
										"name": "index",
										"documentation": "",
										"type": {
											"kind": "Named",
											"name": "number",
											"id": 9
										},
										"optional": false
									}
								],
								"returnType": {
									"kind": "Named",
									"name": "void",
									"id": 14
								}
							},
							"optional": false
						}
					]
				},
				"36": {
					"id": "36",
					"kind": "Component",
					"exportedIn": [
						{
							"path": "dist/src/react-toolbox/index.js",
							"name": "VerticalStepper"
						}
					],
					"name": "VerticalStepper",
					"documentation": "A component that renders the mobile version of the vertical stepper\nfrom the [material design guidlines](https://material.io/guidelines/components/steppers.html#steppers-types-of-steppers)",
					"properties": [
						{
							"name": "activeColor",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "alertColor",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "string",
								"id": 8
							},
							"optional": true
						},
						{
							"name": "children",
							"documentation": "",
							"type": {
								"kind": "Named",
								"name": "ReactNode",
								"id": 112,
								"importedFrom": "react"
							},
							"optional": true
						}
					]
				}
			},
			"reexports": []
		},
		"dist/src/react-toolbox/index.js": {
			"name": "index",
			"srcPath": "src/react-toolbox/index.tsx",
			"outPath": "dist/src/react-toolbox/index.js",
			"declarations": {},
			"reexports": [
				{
					"name": "AdvanceButton",
					"srcName": "AdvanceButton",
					"path": "dist/src/react-toolbox/buttons.js",
					"id": "25"
				},
				{
					"name": "ReverseButton",
					"srcName": "ReverseButton",
					"path": "dist/src/react-toolbox/buttons.js",
					"id": "26"
				},
				{
					"name": "VerticalStepper",
					"srcName": "VerticalStepper",
					"path": "dist/src/react-toolbox/vertical-stepper.js",
					"id": "36"
				}
			]
		}
	},
	"readmes": {
		"dist/src/react-toolbox": "### react-toolbox\nThis contains stepper components that are based on [react-toolbox](http://react-toolbox.com).\nThey use material design and do overall provide a more polished feeling.\n",
		"dist/src": "# react-step\n[![Build Status](https://travis-ci.org/beanloop/react-step.svg?branch=master)](https://travis-ci.org/beanloop/react-step)\n[![npm version](https://badge.fury.io/js/react-step.svg)](https://badge.fury.io/js/react-step)\n[![License](http://img.shields.io/:license-mit-blue.svg)](http://doge.mit-license.org)\n\nA package of React components to easily build advanced steppers.\n\n## Install\n```\nyarn add react-step\nnpm install --save react-step\n```\n\n## Documentation\nFor examples and API documentation please see\n<https://beanloop.github.io/react-step/>\n\n## License\nreact-step is dual-licensed under Apache 2.0 and MIT terms.\n"
	}
};


//////////////////
// WEBPACK FOOTER
// ./docs/analyze-result.json
// module id = 442
// module chunks = 0